import { gql, useMutation } from '@apollo/client'

export const UPDATE_LABEL = gql`
  mutation ($input: ProductUpdate) {
    updateProduct(input: $input) {
      id
      name
      configuration
      gps_status
    }
  }
`

export const useUpdateProduct = () => {
  const [mutate, { data, loading, error }] = useMutation(UPDATE_LABEL, {
    update(cache, { data }) {
      cache.modify({
        fields: {
          getArtists() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
